


























































import RadioGroupModal from "@/components/Molecules/RadioGroupModal/index.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import CoverageAnalysesItem from "@/components/Molecules/CoverageAnalysesItem/index.vue";
import CoverageAnalysesResult from "@/components/Molecules/CoverageAnalysesResult/index.vue";
import { defineComponent, ref } from "vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Simulation } from "@/api/coverageAnalysis";

export default defineComponent({
  components: {
    RadioGroupModal,
    FixedButtonRow,
    CoverageAnalysesItem,
    CoverageAnalysesResult
  },
  data() {
    return {
      prevRouteName: ""
    };
  },
  setup() {
    const showSortModal = ref(false);
    return {
      showSortModal
    };
  },
  beforeRouteEnter(_, from, next) {
    next((vm: any) => {
      const name = from && from.name ? String(from.name) : "";
      vm.prevRouteName = name;
    });
  },
  async mounted() {
    this.$root.$emit("show-loading");
    const fromCoverageFlow = !!this.prevRouteName && String(this.prevRouteName).startsWith("analise_cobertura");
    if (!fromCoverageFlow) {
      this.SET_SIMULATIONS_SORT_OPTION("");
    }
    await this.validateLimit();

    const result = await this.fetchSimulations();
    if (!result) {
      Swal.fire({
        icon: "error",
        text: "Não foi possível carregar a lista de exames",
        confirmButtonText: "OK"
      });
    }
    this.SET_SEARCH_EXAMS([]);
    this.SET_SELECTED_EXAMS([]);
    this.SET_SEARCH_LABS([]);

    this.$root.$emit("hide-loading");
  },
  computed: {
    ...mapState("auths", ["newAuthSuccess"]),
    ...mapState("coverageAnalysis", ["authorized", "simulations", "searchExams", "simulationsSortOption"]),
    authorizedState(): boolean {
      return this.authorized;
    },
    activeSort: {
      get(): string {
        return this.simulationsSortOption || "";
      },
      set(value: string) {
        this.SET_SIMULATIONS_SORT_OPTION(value || "");
      }
    },
    items(): Simulation[] {
      return this.simulations;
    },
    sortedItems(): Simulation[] {
      const list: Simulation[] = this.items || [];
      const opt = (this.activeSort || "").trim();
      if (!opt) return list;

      const parseBrDate = (dateStr: string): Date | null => {
        if (!dateStr || typeof dateStr !== "string") return null;
        const parts = dateStr.split("/");
        if (parts.length !== 3) return null;
        const d = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        const y = parseInt(parts[2], 10);
        if (!d || !m || !y) return null;
        return new Date(y, m - 1, d);
      };

      const withDates = list
        .map(s => ({ s, dt: parseBrDate(s.SalvoEm) }))
        .filter(x => x.dt instanceof Date && !isNaN(x.dt!.getTime()));
      const withoutDates = list.filter(s => !withDates.some(x => x.s === s));

      if (opt === "Ultimos 30 dias") {
        const now = new Date();
        const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);
        return withDates
          .filter(x => x.dt! >= cutoff)
          .sort((a, b) => b.dt!.getTime() - a.dt!.getTime())
          .map(x => x.s);
      }

      if (opt === "Mais recente") {
        return [...withDates.sort((a, b) => b.dt!.getTime() - a.dt!.getTime()).map(x => x.s), ...withoutDates];
      }

      if (opt === "Mais antigo") {
        return [...withDates.sort((a, b) => a.dt!.getTime() - b.dt!.getTime()).map(x => x.s), ...withoutDates];
      }

      return list;
    }
  },
  methods: {
    ...mapActions("coverageAnalysis", ["validateLimit", "fetchSimulations"]),
    ...mapMutations("coverageAnalysis", [
      "SET_SEARCH_EXAMS",
      "SET_SELECTED_EXAMS",
      "SET_SEARCH_LABS",
      "SET_SIMULATIONS_SORT_OPTION"
    ]),
    handleClick() {
      this.$router.push({
        name: "analise_cobertura.nova_analise"
      });
    }
  }
});
